/* eslint-disable brace-style */
import LocalStorage from 'Utils/localStorage';
import { dateToJavaTimeConverterGTM } from 'Utils/dateConverters';
import { SPORTSBOOK, FILTER_DATA_TYPES } from 'Store/constants/sportTypes';
import { TRIBUN_FILTER_SORT_OPTIONS } from 'Store/constants/tribun';
const { SORT, FILTER_V2 } = TRIBUN_FILTER_SORT_OPTIONS;

export const addOddAddedPoint = path => {
  let entryPoint = '';
  if (path === '/')
    entryPoint = 'Anasayfa';
  else if (path.includes('/lig-merkezi'))
    entryPoint = 'Lig Merkezi';
  else if (path.includes('/tribun/'))
    entryPoint = 'Tribün Kupon';
  else if (path.includes('/kupon/'))
    entryPoint = 'Kupon Detay';
  else if (path.includes('/kuponlarim/'))
    entryPoint = 'Kuponlarım';
  else if (path.includes('/canli-iddaa'))
    entryPoint = 'Canlı Bülten';
  else if (path.includes('/kupon-ozet'))
    entryPoint = 'Coupon Success';
  else if (path.includes('/iddaa/') || path.includes('/iddaa')) {
    if (path.includes('/sana-ozel-maclar/canli'))
      entryPoint = 'Populer Live Bulten - Sana Ozel';
    else if (path.includes('/sana-ozel-maclar/yakinda-baslayacak'))
      entryPoint = 'Populer Pre Bulten - Sana Ozel';
    else if (path.includes('/trend-olan-maclar/canli'))
      entryPoint = 'Populer Live Bulten - Trend';
    else if (path.includes('/trend-olan-maclar/yakinda-baslayacak'))
      entryPoint = 'Populer Pre Bulten - Trend';
    else if (path.includes('/populer-bahisler')) {
      if (path.includes('/populer-bahisler/basketbol'))
        entryPoint = 'Populer Bulten - En Populer - Basketball';
      else if (path.includes('/populer-bahisler/tenis'))
        entryPoint = 'Populer Bulten - En Populer - Tennis';
      else if (path.includes('/populer-bahisler/e-spor'))
        entryPoint = 'Populer Bulten - En Populer - E-Sport';
      else
        entryPoint = 'Populer Bulten - En Populer - Football';
    }
    else
      entryPoint = 'Bülten';
  }
  else if (path.includes('/oranlar') && path.includes('/mac-karti/'))
    entryPoint = 'Oranlar';
  else if (path.includes('/sicak-bahisler') && path.includes('/mac-karti/'))
    entryPoint = 'Maç Kartı Sıcak Bahisler';
  else if (path.includes('/bahista') && path.includes('/mac-karti/'))
    entryPoint = 'Maç Kartı Bahista';
  else if (path.includes('/detay') && path.includes('/mac-karti/'))
    entryPoint = 'Canlı';
  else if (path.includes('/yazarlar') || (path.includes('/yazarlar') && path.includes('/mac-karti/')))
    entryPoint = 'Yazar Yorumları';
  else if (path.includes('/kuponlar') && path.includes('/mac-karti/'))
    entryPoint = 'Maç Kartı/Tribün';
  else if (path.includes('/karsilastirma') && path.includes('/mac-karti/'))
    entryPoint = 'Karşılaştırma';
  else if (path.includes('/akilli-analiz') && path.includes('/mac-karti/'))
    entryPoint = 'Akıllı Analiz';
  else if (path.includes('/yazar') && path.includes('/mac-karti/'))
    entryPoint = 'Tribün-Yazarlar';
  else if (path.includes('/anasayfa-arama'))
    entryPoint = 'Main Page Search-Popular';
  else if (path.includes('/kupon-getir'))
    entryPoint = 'Kupon Getir';

  return entryPoint;
};

export const pageFinder = path =>{
  let pagePoint = '';

  if (path.includes('/tribun/')) {
    if (path.includes('/arama')) {
      pagePoint = 'Arama Sayfası';

    } else if (path.includes('/profil/')) {
      pagePoint = 'Profil Sayfası';
    } else if (path.includes('/kupon/')) {
      pagePoint = 'Kupon Sayfası';
    } else if (path.includes('/lider-100')
      || path.includes('/en-cok-takip-edilenler')
      || path.includes('/takip-ettiklerim')
      || path.includes('/tum-uyeler')) {
      pagePoint = 'Liste Sayfası';
    }
  } else if (path.includes('/yazar-detay/')) {
    pagePoint = 'Yazarlar';
  } else if (path.includes('/kupon-ozet')) {
    pagePoint = 'Coupon Success';
  }
  return pagePoint;
};

export const finderTab = path => {
  let filterObj = {
    tabPoint: '',
    sort: '',
    sortField: '',
    filter: '',
    tabType: '',
  };
  if (path.includes('/tribun/')) {
    if (path.includes('/lider-100')) {
      filterObj.tabPoint = 'Lider 100';
      filterObj.tabType = 'leader';
      filterObj.sort = LocalStorage.get('tribunHeaderSortOptions')?.leader?.sortOrder
        ? LocalStorage.get('tribunHeaderSortOptions')?.leader?.sortOrder
        : 'DESC';
      filterObj.sortField = LocalStorage.get('tribunHeaderSortOptions')?.leader?.sortField
        ? LocalStorage.get('tribunHeaderSortOptions')?.leader?.sortField
        : 'date';
      filterObj.filter = LocalStorage.get('tribunHeaderFilterOptions')?.leader?.coupon;
    } else if (path.includes('/en-cok-takip-edilenler')) {
      filterObj.tabPoint = 'Populer 100';
      if (LocalStorage.get('tribunHeaderSortOptions') && LocalStorage.get('tribunHeaderSortOptions').popular) {
        filterObj.sort = LocalStorage.get('tribunHeaderSortOptions').popular.sortOrder;
        filterObj.sortField = LocalStorage.get('tribunHeaderSortOptions').popular.sortField;
      } else {
        filterObj.sort = 'DESC';
        filterObj.sortField = 'date';
      }
      filterObj.filter = LocalStorage.get('tribunHeaderFilterOptions')?.popular?.coupon;
    } else if (path.includes('/takip-ettiklerim')) {
      filterObj.tabPoint = 'Takip Ettiklerim';
      filterObj.tabType = 'following';
      filterObj.sort = LocalStorage.get('tribunHeaderSortOptions')?.following?.sortOrder
        ? LocalStorage.get('tribunHeaderSortOptions')?.leader?.sortField
        : 'DESC';
      filterObj.sortField = LocalStorage.get('tribunHeaderSortOptions')?.following?.sortField
        ?  LocalStorage.get('tribunHeaderSortOptions')?.following?.sortField
        : 'date';

      filterObj.filter = LocalStorage.get('tribunHeaderFilterOptions')?.following?.coupon
        ? LocalStorage.get('tribunHeaderFilterOptions')?.following?.coupon
        : 'all';
    } else if (path.includes('/tum-uyeler')) {
      filterObj.tabPoint = 'Tüm Üyeler';
      filterObj.tabType = 'all';
      filterObj.sort = LocalStorage.get('tribunHeaderSortOptions')?.all?.sortOrder
        ? LocalStorage.get('tribunHeaderSortOptions')?.all?.sortOrder
        : 'DESC';
      filterObj.sortField = LocalStorage.get('tribunHeaderSortOptions')?.all?.sortField
        ? LocalStorage.get('tribunHeaderSortOptions')?.all?.sortField
        : 'date';

      filterObj.filter = LocalStorage.get('tribunHeaderFilterOptions')?.all?.coupon
        ? LocalStorage.get('tribunHeaderFilterOptions')?.all?.coupon
        : 'all';
    } else if (path.includes('/arama')) {
      filterObj.tabPoint = 'Arama';
      filterObj.tabType = 'search';
      filterObj.sort = LocalStorage.get('tribunHeaderSortOptions')?.search?.sortOrder
        ? LocalStorage.get('tribunHeaderSortOptions')?.search?.sortOrder
        : 'DESC';
      filterObj.sortField = LocalStorage.get('tribunHeaderSortOptions')?.search?.sortField
        ? LocalStorage.get('tribunHeaderSortOptions')?.search?.sortField
        : 'date';

      filterObj.filter = LocalStorage.get('tribunHeaderFilterOptions')?.search?.coupon
        ? LocalStorage.get('tribunHeaderFilterOptions')?.search?.coupon
        : 'all';
    } else if (path.includes('/profil')) {
      filterObj.tabPoint = 'Profil';
    } else if (path.includes('/kazananlar')) {
      filterObj.tabType = 'won';
    }

  }

  if (path.includes('/mac-karti/')) {
    if (path.includes('/kuponlar')) {
      filterObj.tabPoint = 'Maç Kartı/Tribün';
      filterObj.tabType = 'match-card';
      filterObj.sort = LocalStorage.get('matchCardTribunSorting')?.sortOrder
        ? LocalStorage.get('matchCardTribunSorting')?.sortOrder
        : 'DESC';
      filterObj.sortField = LocalStorage.get('matchCardTribunSorting')?.sortField
        ? LocalStorage.get('matchCardTribunSorting')?.sortField
        : 'bet';
    }
  }
  return filterObj;
};
export const getCouponSetlement = status =>{

  let settlement = '';
  if ( status === 'won' || status === 'lost') {
    settlement = 'Bitti';
  } else if (status === 'created') {
    settlement = 'Başlamadı';
  } else if (status === 'played') {
    settlement = 'Oynanıyor';
  }
  return settlement;
};

export const getCouponHasLive = selections =>{
  const hasLiveEvent = selections.some(item => item.isLive);
  return hasLiveEvent;
};

export const timeConverter = time =>{
  const date = dateToJavaTimeConverterGTM(time);
  return date;
};
export const isLiveEvent = couponDetail=>{
  let isLive = false;
  couponDetail.forEach(event => {
    if (event.isLive === true) {
      isLive = true;
    }
  });
  return isLive;
};
export const shareCouponPlace = coupon =>{
  let isSharedFromCoupons = false;
  if (coupon?.coupon) {
    isSharedFromCoupons = false;
  } else {
    isSharedFromCoupons = true;
  }
  return isSharedFromCoupons;
};

export const tribunUsernameCheck = username => {
  return username === SPORTSBOOK ? '' : username;
};

export const couponCountCheck = (coupon, actionCoupon) =>{
  if (coupon?.hasLiveEvent === false && coupon?.playedCouponCount ) {
    return coupon?.playedCouponCount;
  } else if (actionCoupon?.coupon?.couponCount) {
    return actionCoupon.coupon.couponCount;
  } else if (actionCoupon?.childCouponsSize) {
    return ( actionCoupon.childCouponsSize + 1 );
  } else {
    return 1;
  }
};

export const hasLiveEventConverter = coupon=>{
  let betType = '';
  if (coupon?.hasLiveEvent === false || coupon?.coupon?.hasLiveEvent === false ) {
    betType = 'İddaa';
  } else {
    betType = 'Canlı';
  }
  return betType;
};

export const costConverter = cost =>{
  return parseFloat(cost);
};

export const bultenOrderFilterStatus = (filter, auth) => {
  let orderFilterStatus = 'Saate Göre';
  if (filter?.[FILTER_DATA_TYPES.sortByLeague]) {
    orderFilterStatus = 'Lige Göre';
  } else if (filter?.[FILTER_DATA_TYPES.BYPERSONAL]) {
    orderFilterStatus = auth.isAuthenticated && auth.data.isAcceptedPersonalizationPolicy ? 'Sana Ozel' : 'Populer';
  }

  return orderFilterStatus;
};

export const tribunPageTypeHelper = type => {
  switch (type) {
    case 'followings':
      return 'Takip Liste Sayfası';
    case 'followers':
      return 'Takipçi Liste Sayfası';
    case 'profile':
      return 'Profil Sayfası';
    default:
      return null;
  }
};

export const muteMutePointHelper = tabType => {
  const mapping = {
    profile: 'Profil',
    leader: 'Lider 100',
    following: 'Takip Ettiklerim',
    all: 'Tüm Üyeler',
    won: 'Kazananlar',
    mutedUsers: 'Sessize Aldığım Kullanıcılar'
  };
  return mapping[tabType] || tabType;
};


export const trackTribunMainPageEvent = ({
  tabType,
  sortingOptions,
  filterTabs,
  mixpanelInstance,
  eventType,
}) => {


  const { filterKeyMap, defaultSelectedFilters } = FILTER_V2;

  const storedSortOptions = LocalStorage.get(SORT.localStorageKey) || {};
  const selectedSortOption = storedSortOptions[tabType];

  const defaultSortOption = sortingOptions?.data?.[0];
  const sortingText = selectedSortOption?.value || defaultSortOption?.value;

  const appliedFilters = LocalStorage.get(FILTER_V2.appliedFiltersLocalStorageKey) || {};

  const mixPanelFilterData = buildTribunMixPanelFilterData(
    appliedFilters,
    filterTabs,
    filterKeyMap,
    tabType,
    defaultSelectedFilters
  );

  const mixpanelEventData = ['search', 'match-card'].includes(tabType)
    ? {
      'Sorting Type': sortingText,
      'Applied Filter': mixPanelFilterData.activeFilterList,
      'Filter Tab Name': mixPanelFilterData.activeFilterTabNames,
    }
    : {
      'Active Sort': sortingText,
      'Active Filter': mixPanelFilterData.activeFilterList,
      'Active Filter Tab Name': mixPanelFilterData.activeFilterTabNames,
      'Tab Name': mixPanelFilterData.activeTabName,
    };

  let eventName = 'View Tribün Main Page';

  if (tabType === 'search') {
    if (eventType === 'sort') {
      eventName = 'Change Sorting Type in Tribun Search';
    } else if (eventType === 'filter') {
      eventName = 'Apply Filter Type in Tribun Search';
    }
  } else if (tabType === 'match-card') {
    if (eventType === 'sort') {
      eventName = 'Change Sorting Type in Event Detail - Tribün Coupons';
    } else if (eventType === 'filter') {
      eventName = 'Apply Filter Type in Event Detail - Tribün Coupons';
    }
  }

  if (mixpanelInstance?.track) {
    mixpanelInstance.track(eventName, mixpanelEventData);
  }
};


export const buildTribunMixPanelFilterData = (appliedFilters, filterTabs, filterKeyMap, tabType, defaultSelectedFilters = {}) => {
  const activeFilterList = [];
  const activeFilterTabNames = [];
  const tabTypeMapping = {
    leader: 'Lider 100',
    following: 'Takip Ettiklerim',
    all: 'Tüm Üyeler',
    won: 'Kazananlar',
  };

  const currentTabFilters
    = appliedFilters?.[tabType] && Object.keys(appliedFilters[tabType]).length > 0
      ? appliedFilters[tabType]
      : defaultSelectedFilters;


  const formatRangeValue = (min, max, unit = '') => {
    if (!min && !max) return null;
    const minStr = min || '';
    const maxStr = max || '';
    const unitStr = unit ? ` ${unit}` : '';
    return `${minStr} - ${maxStr}${unitStr}`;
  };

  filterTabs.forEach(filterTab => {
    const tabName = filterTab.tabName;
    if (!tabName) return;

    const filterKeyMapEntry = filterKeyMap[filterTab.tabKey] ? filterTab.tabKey : null;

    let hasActiveFilter = false;
    let filterValue = null;

    if (filterKeyMapEntry) {


      const filterConfig = filterKeyMap[filterKeyMapEntry];


      if (filterConfig.isRange) {
        const [minKey, maxKey] = filterConfig.inputKeys;
        const minValue = currentTabFilters[minKey];
        const maxValue = currentTabFilters[maxKey];

        if (minValue || maxValue) {
          filterValue = formatRangeValue(minValue, maxValue, filterTab.unit);
          hasActiveFilter = true;
        }
      } else if (filterConfig.isMultiSelect) {
        const inputKey = filterConfig.inputKeys[0];
        const selectedIds = currentTabFilters[inputKey];

        if (selectedIds && selectedIds.length > 0) {
          const selectedOptions = filterTab.options
            ?.filter(opt => selectedIds.includes(opt.key))
            .map(opt => opt.value);

          if (selectedOptions && selectedOptions.length > 0) {
            filterValue = selectedOptions.join(', ');
            hasActiveFilter = true;
          }
        }
      } else {
        const inputKey = filterConfig.inputKeys[0];
        const selectedValue = currentTabFilters[inputKey];

        if (selectedValue) {
          if (filterTab.options?.length > 0) {
            const option = filterTab.options.find(opt => opt.key === selectedValue);
            if (option) {
              filterValue = option.value;
              hasActiveFilter = true;
            }
          } else if (filterTab.values && filterTab.values.includes(String(selectedValue))) {
            filterValue = String(selectedValue);
            hasActiveFilter = true;
          }
        }
      }

    }

    if (hasActiveFilter && filterValue) {
      activeFilterTabNames.push(tabName);
      activeFilterList.push(`${tabName} - ${filterValue}`);
    } else {
      activeFilterList.push('-');
    }
  });

  return {
    activeFilterList,
    activeFilterTabNames,
    activeTabName: tabTypeMapping[tabType] || tabType || ''
  };
};


